import React from "react";
import FacebookIcon from "mdi-material-ui/Facebook";

export default function Facebook(props) {
  return <FacebookIcon htmlColor="#3c5999" {...props} />;
}
